module.exports = __webpack_public_path__ + "static/img/tijiao@2x.32f63f97.png";